import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/storage';

var firebaseConfig = {
    apiKey: "AIzaSyCpMMBAS50ZN2mxpBZiFGOwKQNr6ThpTwk",
    authDomain: "frisbee-app.firebaseapp.com",
    databaseURL: "https://frisbee-app.firebaseio.com",
    projectId: "frisbee-app",
    storageBucket: "frisbee-app.appspot.com",
    messagingSenderId: "465445767631",
    appId: "1:465445767631:web:27c1dd5cc017c954e0aaba",
    measurementId: "G-B31JTBXSH7"
};
  // Initialize Firebase
const fb = firebase.initializeApp(firebaseConfig);
export const db = fb.firestore();
export const firebaseStore= fb.storage();